// Events API Service for El Bethel Ministries

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

class EventsAPI {
  // Get all events
  async getEvents(status = 'active') {
    try {
      const response = await fetch(`${API}/events?status=${status}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching events:', error);
      throw error;
    }
  }

  // Get single event
  async getEvent(eventId) {
    try {
      const response = await fetch(`${API}/events/${eventId}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching event:', error);
      throw error;
    }
  }

  // Create event (admin only)
  async createEvent(eventData) {
    try {
      const response = await fetch(`${API}/events`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(eventData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating event:', error);
      throw error;
    }
  }

  // Submit RSVP
  async submitRSVP(eventId, rsvpData) {
    try {
      const response = await fetch(`${API}/events/${eventId}/rsvp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...rsvpData,
          event_id: eventId
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error submitting RSVP:', error);
      throw error;
    }
  }

  // Get event RSVPs (admin only)
  async getEventRSVPs(eventId) {
    try {
      const response = await fetch(`${API}/events/${eventId}/rsvps`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching RSVPs:', error);
      throw error;
    }
  }

  // Track event analytics
  async trackEvent(eventId, actionType, userData = null) {
    try {
      const response = await fetch(`${API}/events/${eventId}/analytics?action_type=${actionType}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        console.warn('Analytics tracking failed');
      }

      return response.ok;
    } catch (error) {
      console.warn('Analytics tracking error:', error);
      return false;
    }
  }

  // Generate QR Code URL
  generateQRCode(eventId) {
    const eventUrl = `${window.location.origin}/events/${eventId}`;
    return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(eventUrl)}`;
  }
}

// Export singleton instance
export default new EventsAPI();